module.exports = __webpack_public_path__ + "static/img/6.2398279.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/6.png
// module id = RZzY
// module chunks = 0